import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Home from "../Routes/Home";

export default () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
      </Routes>
    </HashRouter>
  );
};
